import { RangeSlider } from 'components/Scl/Form/Field/RangeSlider'
import { HasClassName } from 'models/HasClassName'
import { FunctionComponent } from 'react'
import { useRange } from 'hooks/range'
import { Options } from 'nouislider'

export interface Props extends HasClassName {
  value: any
  input: any
}

export const BusinessLoanPeriodSlider: FunctionComponent<Props> = ({ input, value, className }) => {
  const { asStepValues } = useRange()

  const options: Options = {
    range: asStepValues([6, 12, 18, 24, 36, 48]),
    start: Number(value),
    connect: 'lower',
    snap: true,
  }

  const onInputHandler = (event: string[]) => {
    const value = parseInt(event[0])
    input(value)
  }

  return (
    <RangeSlider
      className={className}
      options={options}
      input={onInputHandler}
    />
  )
}
